/**
 * @flow
 */
'use strict';

export const ocularSurgeryProcedureCodes = [
{"code":"None"},
{"code":"Laser eye surgery"},
{"code":"Cataract surgery"},
{"code":"Glaucoma surgery"},
{"code":"Canaloplasty"},
{"code":"Refractive surgery"},
{"code":"Corneal surgery"},
{"code":"Vitreo-retinal surgery"},
{"code":"Eye muscle surgery"},
{"code":"Oculoplastic surgery"},
{"code":"Eyelid surgery"},
{"code":"Orbital surgery"}
]
